
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CountdownTimers from '../../components/feature/CountdownTimers';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CoursesSection from './components/CoursesSection';
import ElementarySection from './components/ElementarySection';
import JuniorHighSection from './components/JuniorHighSection';
import SeniorHighSection from './components/SeniorHighSection';
import CampsSection from './components/CampsSection';
import CharitySection from './components/CharitySection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CountdownTimers />
      <main>
        <HeroSection />
        <AboutSection />
        <CoursesSection />
        <ElementarySection />
        <JuniorHighSection />
        <SeniorHighSection />
        <CampsSection />
        <CharitySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
